export default __webpack_public_path__ + "static/media/Code of Ethics_2026_ENG.285c2cbc.pdf";